import { Loading } from '@alifd/next';
import ErrorBoundary from '@aligov/error-monitor';
import useSyncUserType from '@recept-pc-sdk/extensions/hooks/useSyncUserType';
import handleMultipleQuery from '@recept-pc-sdk/utils/getQuery';
import { getDynamicDomain } from '@recept-pc-sdk/utils';
import React from 'react';

require('./index.module.less');

const BasicLayout: React.FC = (props: any) => {
  const { showContent = false } = useSyncUserType({
    query: handleMultipleQuery(),
    domain: getDynamicDomain(),
  });

  if (!showContent) {
    return (
      <div style={{ padding: '150px 0' }}>
        <Loading tip="加载中..." style={{ display: 'block' }} />
      </div>
    );
  }

  return (
    <div>
      <div>
        <ErrorBoundary
          errorMsg={GFF_CTX.text('errorBoundaryReportKey') || 'recept-pc-zhejiang'}
          eventName={GFF_CTX.text('blankMonitorEventName') || 'recept-pc-zhejiang-blank-monitor'}
          autoTouchEvent={true}
          style={{ margin: '100px 0', textAlign: 'center' }}
        >
          {props.children}
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default BasicLayout;
